import React from "react";
import { getMediaUrl } from "../../services/media.ts";

const MedicalImageItem = ({ medicalImage }) => {
  const relativePath = medicalImage?.image;
  const finalImageUrl = relativePath ? getMediaUrl(relativePath) : null;

  return (
    <tr>
      {/* Patient ID */}
      <td>{medicalImage.patient_id}</td>

      {/* Image Preview */}
      <td>
        {finalImageUrl ? (
          <img
            src={finalImageUrl}
            alt="Medical"
            style={{ width: "100px", height: "auto" }}
          />
        ) : (
          <em>No Image</em>
        )}
      </td>

      {/* Description */}
      <td>{medicalImage.description}</td>

      {/* Uploaded At */}
      <td>{new Date(medicalImage.uploaded_at).toLocaleString()}</td>

      {/* Modality */}
      <td>{medicalImage.modality}</td>

      {/* Anatomy */}
      <td>{medicalImage.anatomy}</td>

      {/* Anonimized */}
      <td>{medicalImage.anonymized ? "Yes" : "No"}</td>

      {/* Synthetic */}
      <td>{medicalImage.is_synthetic ? "Yes" : "No"}</td>

      {/* Action */}
      <td>
        <button className="btn btn-primary btn-sm">Check</button>
      </td>
    </tr>
  );
};

export default MedicalImageItem;
